import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../assets/logo.png'; // 👈 Add this line

function Header() {
  return (
    <header className="header">
      {/* Logo and text linked to Home */}
      <Link to="/" className="logo-container">
        <img src={logo} alt="TestYodha Logo" className="logo-img" />
        <span className="logo-text"><span></span></span>
      </Link>

      <nav>
        <Link to="/">Home</Link>
        <Link to="/about">About</Link>
        <Link to="/contact">Contact</Link>
        <Link to="/privacy">Privacy</Link>
        <Link to="/refund">Refund</Link>
        <Link to="/terms">Terms</Link>
        <Link to="/delete-account">Delete Account</Link> 
      </nav>
    </header>
  );
}

export default Header;